import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Link to="/"><Logo /></Link></div>
        <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
          <h1 className="font-heading text-2xl font-bold text-[#0F2747]">Set a new password</h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="password">New password</Label>
              <Input id="password" type="password" data-testid="reset-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} required minLength={8} className="mt-1.5 rounded-xl" />
            </div>
            <Button type="submit" data-testid="reset-submit-btn" className="w-full rounded-full bg-[#18A6A6] py-6 hover:bg-[#148f8f]">
              Update password
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
